import { Stack, Text } from '@zorro/web/design-system';

type BankAccountFieldProps = {
  label: string;
  value: string;
};

const BankAccountField = ({ label, value }: BankAccountFieldProps) => (
  <Stack gap={0}>
    <Text size="sm" c="var(--brand-grayscale-600)">
      {label}
    </Text>
    <Text size="sm">{value}</Text>
  </Stack>
);

export { BankAccountField };
